module.exports = __webpack_public_path__ + "img/romains.e9d2ad33.jpg";